// extracted by mini-css-extract-plugin
export default {"block":"Timer_block__Lbb9U","last_dial":"Timer_last_dial__9WYA4"};